import PropTypes from 'prop-types'

const SvgXyPropType = PropTypes.exact({
  x: PropTypes.number, 
  y: PropTypes.number,
})

export default SvgXyPropType
